<template>
	<div class="flex">
		<core-form-datepicker-input
			v-if="'custom' === filter"
			v-model="dateSelection"
			:open-immediate="true"
			:min-date="minDate"
			align="right"
			:date-range="dateSelection"
		/>
		<core-dropdown-select align="right" :current-value="dateText" :width="width">
			<template #list>
				<li v-if="includeAllTime">
					<a href="#" :class="{ current: '' === filter }" @click.prevent="$emit('quickSelect', '')">
						All Time
					</a>
				</li>
				<li>
					<a
						href="#"
						:class="{ current: '7-days' === filter }"
						@click.prevent="$emit('quickSelect', '7-days')"
					>
						Last 7 Days
					</a>
				</li>
				<li>
					<a
						href="#"
						:class="{ current: '30-days' === filter }"
						@click.prevent="$emit('quickSelect', '30-days')"
					>
						Last 30 Days
					</a>
				</li>
				<li>
					<a
						href="#"
						:class="{ current: 'custom' === filter }"
						@click.prevent="$emit('quickSelect', 'custom')"
					>
						Custom Date Range
					</a>
				</li>
			</template>
		</core-dropdown-select>
	</div>
</template>

<script>
export default {
	props: {
		filter: {
			type: String,
			default: '',
		},
		minDate: {
			type: Date,
			default: () => new Date(2013, 0), // When OM was started?!
		},
		/**
		 * Width
		 */
		width: {
			type: Number,
			default: null,
		},
		includeAllTime: Boolean,
	},
	data() {
		return {
			dateSelection: [],
		};
	},
	computed: {
		dateText() {
			switch (this.filter) {
				case '30-days':
					return 'Last 30 Days';
				case '7-days':
					return 'Last 7 Days';
				case 'custom':
					return 'Custom Date Range';
			}
			return this.includeAllTime ? 'All Time' : '';
		},
	},
	watch: {
		dateSelection([start, end]) {
			this.$emit('dateSelection', {
				filter: 'custom',
				start,
				end,
			});
		},
	},
};
</script>
